import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"
import { Modal } from "bootstrap"

export default class ModalController extends Controller<HTMLElement> {
  static values = {
    autoOpen: Boolean,
    returnTo: String,
  }

  declare autoOpenValue?: boolean
  declare returnToValue?: string
  private modal?: Modal

  connect() {
    this.modal = bootstrap.Modal.getOrCreateInstance(this.element)
    this.element.addEventListener("modal:close", () => this.close())
    if (this.autoOpenValue) this.open()
  }

  open() {
    this.#closeAllOpenModals()
    this.modal?.show()
  }

  close() {
    this.modal?.hide()
    if (this.returnToValue) Turbo.visit(this.returnToValue, { action: "replace", frame: "_top" })
  }

  disconnect() {
    this.element.removeEventListener("modal:close", () => this.close())
    this.modal?.dispose()
  }

  #closeAllOpenModals() {
    document.querySelectorAll(".modal.show").forEach((openModal) => {
      const modalInstance = bootstrap.Modal.getInstance(openModal)
      modalInstance?.hide()
    })
  }
}
